import {Popup} from "antd-mobile";
import CalendarModalFilter from "./calendarModalFilter";

const CalendarModalParentFilter = ({visible, onCancel, code}) => {

    return (
        <Popup
            visible={visible}
            onMaskClick={() => {
                onCancel()
            }}
            onClose={() => {
                onCancel()
            }}
            destroyOnClose={true}
            position={"right"}
            bodyStyle={{width: "100%"}}
        >
            <CalendarModalFilter code={code}
                                 onCancel={onCancel}
                                 visible={visible} />
        </Popup>
    )
}
export default CalendarModalParentFilter
